<ng-template #loading>
  <app-loader-spinner-general
    [loadingType]="LoadingType.INPUT"
  ></app-loader-spinner-general>
  <app-loader-spinner-general
    [loadingType]="LoadingType.INFO"
  ></app-loader-spinner-general>
</ng-template>

<div class="white-box-row" *ngIf="!isLoading; else loading">
  <div class="white-box-header">
    <div class="medium-title fl-l">
      {{ "ACCOUNT_MANAGERS.TITLE" | translate }}
    </div>
    <button
      type="button"
      class="white-box-header-action orange fl-r"
      (click)="openAddDialog()"
      [disabled]="!canOpenDialog"
    >
      {{ "GENERALS.ADD" | translate }}
    </button>
  </div>
  <div class="clear"></div>
  <div class="white-box-body">
    <div class="account-managers-list" *ngIf="accountManagers.length > 0">
      <div
        class="account-manager-item"
        *ngFor="let accountManager of accountManagers"
      >
        <div class="account-manager-label">
          {{ accountManager.label }}
        </div>
        <button
          type="button"
          class="account-manager-delete"
          (click)="removeAccountManager(accountManager.id)"
          [disabled]="isUpdating"
        >
          <i class="icon-trash"></i>
        </button>
      </div>
    </div>

    <div class="account-managers-empty" *ngIf="accountManagers.length === 0">
      {{ "ACCOUNT_MANAGERS.EMPTY" | translate }}
    </div>
  </div>
</div>
